export default class IssueList {

	constructor (data) {
		this.data = data

		// Build id index
		this.index = {}
		for (let entry of this.data) {
			this.index[entry.id] = entry
		}
	}

	static async fetch () {

		let data = await Anvil.REST.get('/issue')

		return new IssueList(data)
	}

	static async fetchForUser (user_id) {

		let data = await Anvil.REST.get(`/user/${user_id}/issue`)

		return new IssueList(data)
	}

	getById (id) {
		return this.index[id]
	}
}
